import useAppSelector from './useAppSelector';

export default function useCurrencyCode() {
  return useAppSelector(state => state.currencyCode);
}
